import { j as a } from "./jsx-runtime-3tyXYecC.mjs";
import { forwardRef as u } from "react";
import { I as v } from "./icon-CvGUqXUP.mjs";
import { c as l } from "./index-DkZ16bcJ.mjs";
import { m as T } from "./tss-DN0acMKN.mjs";
import { M as I, d as N } from "./constants-CnFYFetN.mjs";
import { T as R } from "./Typography-DfkimCSn.mjs";
const b = T()(({ palette: s, spacing: o, mode: i }, t) => {
  var e, n;
  const { alignTop: c, marginLarge: d, iconColor: r } = t;
  return {
    root: {
      display: "flex",
      alignItems: c ? "top" : "center",
      outline: i === I.Dye ? `1px solid ${N.main}` : void 0
    },
    asset: {
      marginRight: d ? "12px" : "8px",
      marginTop: o(0.5)
    },
    iconWrapper: {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      fill: r ? ((e = s[r]) == null ? void 0 : e.main) || ((n = s[r]) == null ? void 0 : n.active) || r : null
    },
    image: {
      borderRadius: "50%"
    }
  };
}), S = u(
  ({
    className: s,
    classes: o = {},
    children: i,
    iconName: t,
    icon: c,
    iconColor: d = "primary",
    imageSrc: r,
    imageAlt: e = "",
    imageWidth: n = "auto",
    imageHeight: x = "auto",
    title: f,
    TitleProps: y = {},
    ...h
  }, j) => {
    const g = !!i, { classes: m } = b({
      alignTop: g,
      iconColor: d,
      marginLarge: g
    }), p = c || t;
    return /* @__PURE__ */ a.jsxs("div", { className: l(s, m.root, o.root), ref: j, ...h, "data-fabric-component": "Badge", children: [
      /* @__PURE__ */ a.jsxs("div", { className: l(m.asset, o.asset), children: [
        p && /* @__PURE__ */ a.jsx("div", { className: l(m.iconWrapper, o.iconWrapper), children: typeof p == "string" ? /* @__PURE__ */ a.jsx(v, { name: p }) : p }),
        r && !t && /* @__PURE__ */ a.jsx(
          "img",
          {
            alt: e,
            className: l(m.image, o.image),
            height: x,
            src: r,
            width: n
          }
        )
      ] }),
      /* @__PURE__ */ a.jsxs("div", { className: o.content, children: [
        /* @__PURE__ */ a.jsx(R, { color: "primary", component: "span", display: "block", variant: "h4", ...y, children: f }),
        i
      ] })
    ] });
  }
);
export {
  S as B
};
//# sourceMappingURL=badge-BnvQvS3o.mjs.map
